import * as React from 'react';

function SvgLandlordRelatedInformation(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" {...props}>
      <path
        fill="#E4F2EE"
        fillRule="evenodd"
        d="M33.416 7.52c8.133 0 14.72 6.586 14.72 14.719 0 5.28-2.8 9.905-6.994 12.49a25.468 25.468 0 0 1 5.637 2.52l1.101-1.038c.87-.815 2.19-.816 3.016.008l11.591 11.205c.429.43.654.977.654 1.58v11.203c0 1.205-.985 2.19-2.19 2.19h-1.949v.003H8.198A25.853 25.853 0 0 1 8 59.2c0-8.732 4.372-16.444 11.047-21.064a23.008 23.008 0 0 1 6.516-3.487l-.403-.263a14.658 14.658 0 0 1-6.462-12.147c0-8.105 6.6-14.719 14.718-14.719Z"
        clipRule="evenodd"
      />
      <path
        fill="#38B2A6"
        fillRule="evenodd"
        d="M40.615 16.319C40.615 8.186 34.03 1.6 25.897 1.6c-8.118 0-14.719 6.614-14.719 14.719 0 4.94 2.478 9.453 6.462 12.147l.403.263A23.136 23.136 0 0 0 8.483 35C4.045 39.829 1.6 46.569 1.6 53.924c0 .992.77 1.763 1.763 1.763a1.74 1.74 0 0 0 1.763-1.763c0-13.117 8.405-22.648 20.16-22.943l.503.013.533-.006c7.917-.224 14.293-6.701 14.293-14.67Zm10.677 24.438L39.703 29.55c-.827-.824-2.147-.823-3.017-.008l-11.973 11.29c-.435.38-.706.983-.706 1.589v11.117c0 1.206.984 2.19 2.19 2.19h23.56c1.206 0 2.19-.984 2.19-2.19V42.336c0-.602-.225-1.15-.654-1.58Zm-13.128-7.805L27.53 42.97v9.233h8.874v-6.195c0-.992.771-1.763 1.763-1.763.926 0 1.66.672 1.753 1.568l.01.195-.002 6.194h8.491v-9.321l-10.256-9.93Zm-23.46-16.633c0-6.177 5.029-11.193 11.193-11.193 6.172 0 11.193 4.982 11.193 11.15a11.18 11.18 0 0 1-10.583 11.177l-.38.014-.135-.015-.138-.006-.538.01-.385-.026A11.134 11.134 0 0 1 14.703 16.32Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default SvgLandlordRelatedInformation;
